import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './duration-price.component'

let module = angular.module('durationPrice', [
  uiRouter
])

.component('durationPrice', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/duration-price/index.js